export default __webpack_public_path__ + "static/unacademy-d6c0e882346991c3d588e3ee9ad9dc18.png";